import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import ProposalCard from './ProposalCard';
import { getStageCardCountLabel } from '@/modules/deals/utils';

const ProposalList = ({
  proposalStages,
  proposals,
  onCardClick,
  onOpenClient,
  onOpenStaff,
  onDragEnd,
  staff = [],
}) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="deals-board" data-testid="deals-kanban-board">
        <div className="deals-board__grid">
          {proposalStages.map((stage) => {
            const stageProposals = proposals.filter((proposal) => proposal.stage === stage);

            return (
              <section key={stage} className="deals-column">
                <div className="deals-column__header">
                  <h3 className="deals-column__title">{stage}</h3>
                  <p className="deals-column__count">{getStageCardCountLabel(stageProposals.length)}</p>
                </div>

                <Droppable droppableId={stage}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className={snapshot.isDraggingOver ? 'deals-column__body is-over' : 'deals-column__body'}
                    >
                      {stageProposals.map((proposal, index) => (
                        <Draggable
                          key={proposal.id}
                          draggableId={String(proposal.id)}
                          index={index}
                        >
                          {(providedDraggable, snapshotDraggable) => (
                            <ProposalCard
                              proposal={proposal}
                              onClick={onCardClick}
                              onOpenClient={onOpenClient}
                              onOpenStaff={onOpenStaff}
                              staff={staff}
                              provided={providedDraggable}
                              snapshot={snapshotDraggable}
                            />
                          )}
                        </Draggable>
                      ))}

                      {provided.placeholder}

                      {stageProposals.length === 0 && !snapshot.isDraggingOver && (
                        <div className="deals-column__empty">Nessuna proposta in questa fase</div>
                      )}
                    </div>
                  )}
                </Droppable>
              </section>
            );
          })}
        </div>
      </div>
    </DragDropContext>
  );
};

export default ProposalList;
